<script setup lang="ts">
import { useTimesheetStore, BreakType } from '@/stores/timesheets';
import { getTranslations } from '@/lib/util/i18n';
import ShiftActionStatus from '@/components/ShiftActionStatus.vue';
import BreakConfirmationImage from '@/assets/images/break-confirmation.png';

const t = getTranslations({
  app: '',
  module: 'views',
  file: 'shift-action-status',
});

const timesheets = useTimesheetStore();

const totalNumberOfBreaks: number =
  timesheets.activeTimesheet?.Slots.length || 0;

const breakType =
  timesheets.activeTimesheet?.Slots[totalNumberOfBreaks - 1].mixedActivity
    .strBreakType == BreakType.Unpaid
    ? '(unpaid)'
    : '(paid)';
const breakName =
  timesheets.activeTimesheet?.Slots[totalNumberOfBreaks - 1].strTypeName;
</script>

<template>
  <ShiftActionStatus
    v-if="timesheets.activeTimesheet"
    :is-loading="timesheets.isProcessingShiftAction"
    :has-error="timesheets.hasAnyErrors"
    :image="BreakConfirmationImage"
    :title="
      t('break-ended:title', { breakName: breakName, breakType: breakType })
    "
  ></ShiftActionStatus>
</template>
